import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_4,
} from 'dashboard/routes/dashboard/settings/automation/operators';

const TEXT_OPERATORS = [
  { value: 'equal_to', label: 'Equal to' },
  { value: 'not_equal_to', label: 'Not equal to' },
  { value: 'contains', label: 'Contains' },
  { value: 'does_not_contain', label: 'Does not contain' },
  { value: 'is_present', label: 'Is present' },
  { value: 'is_not_present', label: 'Is not present' },
];

// prettier-ignore
export const PROPERTY_AD_FIELDS = [
  { key: 'property_linked',            name: 'PROPERTY_AD.LINKED',            inputType: 'search_select', filterOperators: OPERATOR_TYPES_1 },
  { key: 'property_active',            name: 'PROPERTY_AD.ACTIVE',            inputType: 'search_select', filterOperators: OPERATOR_TYPES_1 },
  { key: 'property_purpose',           name: 'PROPERTY_AD.PURPOSE',           inputType: 'plain_text',    filterOperators: TEXT_OPERATORS },
  { key: 'property_type',              name: 'PROPERTY_AD.TYPE',              inputType: 'plain_text',    filterOperators: TEXT_OPERATORS },
  { key: 'property_subtype',           name: 'PROPERTY_AD.SUBTYPE',           inputType: 'plain_text',    filterOperators: TEXT_OPERATORS },
  { key: 'property_city',              name: 'PROPERTY_AD.CITY',              inputType: 'plain_text',    filterOperators: TEXT_OPERATORS },
  { key: 'property_neighborhood',      name: 'PROPERTY_AD.NEIGHBORHOOD',      inputType: 'plain_text',    filterOperators: TEXT_OPERATORS },
  { key: 'property_state',             name: 'PROPERTY_AD.STATE',             inputType: 'plain_text',    filterOperators: TEXT_OPERATORS },
  { key: 'property_rental_price',      name: 'PROPERTY_AD.RENTAL_PRICE',      inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_sale_price',        name: 'PROPERTY_AD.SALE_PRICE',        inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_condominium_fee',   name: 'PROPERTY_AD.CONDOMINIUM_FEE',   inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_bedrooms',          name: 'PROPERTY_AD.BEDROOMS',          inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_bathrooms',         name: 'PROPERTY_AD.BATHROOMS',         inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_suites',            name: 'PROPERTY_AD.SUITES',            inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_parking_spots',     name: 'PROPERTY_AD.PARKING_SPOTS',     inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_usable_area',       name: 'PROPERTY_AD.USABLE_AREA',       inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_total_area',        name: 'PROPERTY_AD.TOTAL_AREA',        inputType: 'plain_text',    filterOperators: OPERATOR_TYPES_4 },
  { key: 'property_pool',              name: 'PROPERTY_AD.POOL',              inputType: 'search_select', filterOperators: OPERATOR_TYPES_1 },
  { key: 'property_air_conditioning',  name: 'PROPERTY_AD.AIR_CONDITIONING',  inputType: 'search_select', filterOperators: OPERATOR_TYPES_1 },
  { key: 'property_gated_condominium', name: 'PROPERTY_AD.GATED_CONDOMINIUM', inputType: 'search_select', filterOperators: OPERATOR_TYPES_1 },
];

export const PROPERTY_AD_BOOLEAN_KEYS = [
  'property_linked',
  'property_active',
  'property_pool',
  'property_air_conditioning',
  'property_gated_condominium',
];

// `name` is the suffix of an `AUTOMATION.ATTRIBUTES.*` key: the automation forms translate it,
// like every upstream condition. Passing an already-translated label renders it as a raw key.
export const manifestPropertyAdFields = () => [
  { key: 'property_ad_section', name: 'PROPERTY_AD_LABEL', disabled: true },
  ...PROPERTY_AD_FIELDS,
];
